import { useCallback } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { LeadResult } from "../../../../Models/Lead";
import ILegacyCreateOrUpdateContactResultRequest from "../Types/ILegacyCreateOrUpdateContactResultRequest";

type DelegateHook = TriggeredHook<
  LeadResult,
  ILegacyCreateOrUpdateContactResultRequest,
  ILegacyCreateOrUpdateContactResultRequest
>;

/**
 * A decorator for a pair of {@link DelegateHook} that routes to put or post legacy lead result hooks based on whether
 * a lead result id already exists.
 */
const BuildUsePutPostLeadResultLegacyWrapper: (
  putDelegate: DelegateHook,
  postDelegate: DelegateHook
) => TriggeredHook<LeadResult, ILegacyCreateOrUpdateContactResultRequest, ILegacyCreateOrUpdateContactResultRequest> =
  (putDelegate, postDelegate) => () => {
    const { execute: executePut, result: putResult, error: putError, isLoading: isPutLoading } = putDelegate();
    const { execute: executePost, result: postResult, error: postError, isLoading: isPostLoading } = postDelegate();

    const wrapperExecute = useCallback(
      (request: ILegacyCreateOrUpdateContactResultRequest) => {
        if (request.leadResult.id) {
          executePut(request);
          return;
        }

        executePost(request);
      },
      [executePut, executePost]
    );

    return {
      execute: wrapperExecute,
      result: putResult ?? postResult,
      error: putError ?? postError,
      isLoading: isPutLoading || isPostLoading
    };
  };

export default BuildUsePutPostLeadResultLegacyWrapper;
